import React from 'react';
import { Button } from 'primereact/button';
import './ButtonGroup.scss';

const ButtonGroup = ({ buttons, className = '' }) => {
    const getSeverityClass = (severity) => {
        switch (severity) {
            case 'success':
                return 'p-button-primary';
            case 'gray':
                return 'p-button-secondary';
            case 'danger':
                return 'p-button-danger';
            default:
                return 'p-button-primary';
        }
    };

    return (
        <div className={`custom-button-group ${className}`}>
            {buttons.map((button, index) => (
                <Button key={index} label={button.label} icon={button.icon} onClick={button.onClick} className={`${getButtonClassName(index, buttons.length)} ${getSeverityClass(button.severity)}`} disabled={button.disabled} loading={button.loading} />
            ))}
        </div>
    );
};

const getButtonClassName = (index, totalButtons) => {
    if (totalButtons === 1) return 'rounded-left rounded-right';
    if (index === 0) return 'rounded-left';
    if (index === totalButtons - 1) return 'rounded-right';
    return 'no-radius';
};

export default ButtonGroup;
